<template>
  <div class="app-container">
    <SearchCollapse @update-height="getHeight" :formItemsLength="formItemsLength"  ref="SearchCollapse">
    <div class="formBox" ref="searchBox">
      <!-- 查询条件 -->
      <el-form :inline="true" :model="searchFrom" class="demo-form-inline" size="mini" label-width="100px">
        <div class="formItemBox">
            <el-form-item label="运单编号:" class="item1">
              <el-input placeholder="可支持多个" type="textarea" v-model="searchFrom.wayNo" ></el-input>
            </el-form-item>
             <br>
            <el-form-item label="订单编号:" class="item1">
              <el-input placeholder="可支持多个" type="textarea" v-model="searchFrom.ddbh"></el-input>
            </el-form-item>
              <el-form-item label="创建时间:">
                <el-date-picker
                  v-model="createTimes"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
              </el-form-item>
            <template v-for="column in tabHeadList" >
              <el-form-item label="签收时间:" v-if="column.enName == 'actualSigningTime' && column.isSettingQuery == '1'" :key="column.enName">
                <el-date-picker
                  v-model="actualTimes"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="装车时间:" v-if="column.enName == 'actualLoadingTime' && column.isSettingQuery == '1'" :key="column.enName">
                <el-date-picker
                v-model="actualLoadingTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                :default-time="['00:00:00', '23:59:59']"
              ></el-date-picker>
              </el-form-item>
              <el-form-item label="子公司:" v-if="column.enName == 'createSubcompanyName' && column.isSettingQuery == '1'" :key="column.enName">
                <el-select v-model="searchFrom.companyName" filterable clearable placeholder="请选择" @change="zigsChangeCX">
                  <el-option v-for="item in getCompany" :label="item.companyName" :value="item.companyName" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="接单部门:" v-if="column.enName == 'createSubdepartmentName' && column.isSettingQuery == '1'" :key="column.enName">
                <el-select v-model="searchFrom.subDepartmentName" filterable clearable placeholder="请选择">
                  <el-option v-for="item in bumenList" :label="item.name" :value="item.name" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="车牌号:" v-if="column.enName == 'plateNumber' && column.isSettingQuery == '1'" :key="column.enName">
                <el-input v-model="searchFrom.plateNumber" placeholder="请输入车牌号"></el-input>
              </el-form-item>
              <el-form-item label="司机姓名:" v-if="column.enName == 'driverName' && column.isSettingQuery == '1'" :key="column.enName">
                <el-input v-model="searchFrom.driverName" placeholder="请输入司机姓名"></el-input>
              </el-form-item>
              <el-form-item label="业务人员:" v-if="column.enName == 'businessUser' && column.isSettingQuery == '1'" :key="column.enName">
                <el-input v-model="searchFrom.businessUser" placeholder="请输入业务人员"></el-input>
              </el-form-item>
               <el-form-item label="订单创建人:" v-if="column.enName == 'orderCreateUser' && column.isSettingQuery == '1'" :key="column.enName">
                <el-input v-model="searchFrom.orderCreateUser" placeholder="请输入订单创建人"></el-input>
              </el-form-item>
              <el-form-item label="外部单号" v-if="column.enName == 'externalOrderNumber' && column.isSettingQuery == '1'" :key="column.enName">
                <el-input v-model="searchFrom.wbdh" placeholder="可支持多个" type="textarea"></el-input>
              </el-form-item>
              <el-form-item label="项目名称:" v-if="column.enName == 'projectType' && column.isSettingQuery == '1'" :key="column.enName">
              <el-select v-model="searchFrom.projectType" filterable placeholder="请选择" clearable>
                <el-option  label="全部" value="" ></el-option>
                <el-option v-for="item in xmList" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="车辆归属:"  v-if="column.enName=='vehicleOwnershipName'&& column.isSettingQuery == '1'" :key="column.enName">
                <el-select v-model="searchFrom.vehicleOwnershipName" placeholder="请选择" clearable>
                  <el-option label="全部" value="" ></el-option>
                  <el-option label="自有" value="自有" ></el-option>
                  <el-option label="外协" value="外协" ></el-option>
                </el-select>
              </el-form-item>
            <el-form-item label="运输方式:"  v-else-if="column.enName=='transportModeName'" :key="column.enName">
              <el-select v-model="searchFrom.transportMode" placeholder="请选择" clearable>
                <el-option label="全部" value="" ></el-option>
                <el-option label="汽运" :value="1" ></el-option>
                <el-option label="海运" :value="2" ></el-option>
              </el-select>
            </el-form-item>
              <template v-for="item in column.child" >
                <el-form-item label="结算客户:" v-if="item.enName == 'payee' && item.isSettingQuery == '1'" :key="item.enName">
                  <el-input v-model="searchFrom.payee" placeholder="请输入结算客户"></el-input>
                </el-form-item>
                <el-form-item label="收款方:" v-if="item.enName == 'payer' && item.isSettingQuery == '1'" :key="item.enName">
                  <el-input v-model="searchFrom.payer" placeholder="请输入收款方"></el-input>
                </el-form-item>
                <el-form-item label="收入开票状态:" v-if="item.enName == 'ysInvoicingStates' && item.isSettingQuery == '1'" :key="item.enName">
                  <el-select v-model="searchFrom.ysInvoicingStates" placeholder="请选择" clearable>
                    <el-option label="全部" value="" ></el-option>
                    <el-option label="待申请" value="0" ></el-option>
                    <el-option label="待开票" value="1" ></el-option>
                    <el-option label="部分开票" value="11" ></el-option>
                    <el-option label="已开票" value="2" ></el-option>
                     <el-option label="不开票" value="3" ></el-option>
                  </el-select>
                </el-form-item>
                 <el-form-item label="收入发票号:" v-if="item.enName == 'ysInvoiceOn' && item.isSettingQuery == '1'" :key="item.enName">
                  <el-input v-model="searchFrom.ysInvoiceOn" placeholder="请输入收入发票号"></el-input>
                </el-form-item>
                <el-form-item label="支出发票号:" v-if="item.enName == 'yfInvoiceOn' && item.isSettingQuery == '1'" :key="item.enName">
                  <el-input v-model="searchFrom.yfInvoiceOn" placeholder="请输入支出发票号"></el-input>
                </el-form-item>
                <el-form-item label="收款日期:" v-if="item.enName == 'ysPaymentTime' && item.isSettingQuery == '1'" :key="item.enName">
                  <el-date-picker
                  v-model="ysPaymentTime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
                </el-form-item>
                <el-form-item label="付款日期:" v-if="item.enName == 'yfPaymentTime' && item.isSettingQuery == '1'" :key="item.enName">
                  <el-date-picker
                  v-model="yfPaymentTime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
                </el-form-item>
                <el-form-item label="收款开票日期:" v-if="item.enName == 'ysInvoiceTime' && item.isSettingQuery == '1'" :key="item.enName">
                  <el-date-picker
                  v-model="ysInvoiceTime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
                </el-form-item>
                <el-form-item label="付款开票日期:" v-if="item.enName == 'yfInvoiceTime' && item.isSettingQuery == '1'" :key="item.enName">
                  <el-date-picker
                  v-model="yfInvoiceTime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
                </el-form-item>
              </template>
              <!-- <el-form-item label="运单状态:" v-if="column.enName == 'wayStateName' && column.isSettingQuery == '1'">
                <el-select v-model="searchFrom.wayState" placeholder="请选择">
                  <el-option label="全部" value="" ></el-option>
                  <el-option label="待配载" value="0" ></el-option>
                  <el-option label="待装车" value="1" ></el-option>
                  <el-option label="运输中" value="2" ></el-option>
                  <el-option label="待签收" value="3" ></el-option>
                  <el-option label="已签收" value="4" ></el-option>
                  <el-option label="已作废" value="5" ></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="业务类型:" v-if="column.enName == 'wayBusinessTypeName' && column.isSettingQuery == '1'" :key="column.enName">
                <el-select v-model="searchFrom.wayBusinessTypeName" placeholder="请选择" clearable>
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in YWLXlist" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
            </template>
        </div>
        <div style="display: flex;justify-content: space-between;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox">
            <el-form-item>
              <el-button type="primary" @click="chaxun" size="mini">查询</el-button>
              <el-button type="primary" @click="chongZhi" size="mini">重置</el-button>
              <el-button type="primary" @click="exportFn" :disabled="isDisable" size="mini">导出</el-button>
            </el-form-item>
            <el-form-item>
              <div style="display:flex;">
                <p style="width:15px;height:15px;background:#f9bc04;margin-top: 6px;"></p>
                <span style="margin-left:5px;">毛利润为负数</span>
              </div>
            </el-form-item>
            <el-form-item style="margin-left:8px">
              <p class="margin0" >毛利润:<span class="red">{{dataJson.mlrAmountSum|moneyFormatNew}}</span>元</p>
            </el-form-item>
            <el-form-item>
              <p class="margin0" >毛利率:<span class="red">{{dataJson.mllTaxAll}}</span>%</p>
            </el-form-item>
             <el-form-item>
              <p class="margin0" >利润率:<span class="red">{{dataJson.lrTaxAll}}</span>%</p>
            </el-form-item>
            <el-form-item>
              <p class="margin0" >总结算量:<span class="red">{{dataJson.liquidatedAmountSum}}</span></p>
            </el-form-item>
            <el-form-item>
              <p class="margin0" >总收入含税总额:<span class="red">{{dataJson.grossRevenueSum}}</span>元</p>
            </el-form-item>
            <el-form-item>
              <p class="margin0" >总运费金额:<span class="red">{{dataJson.freightAmountSum}}</span>元</p>
            </el-form-item>
            <el-form-item>
              <p class="margin0" >总支出含税总额:<span class="red">{{dataJson.freightTaxTotalSum}}</span>元</p>
            </el-form-item>
          </div>
          <div style="cursor: pointer;" @click="tabSetting"><i class="el-icon-s-tools"></i></div>
        </div>
      </el-form>
    </div>
     </SearchCollapse>
    <!--表格1-->
    <div :style="{height:h}">
      <el-table :data="tableList" ref="tabref" class="elTab" highlight-current-row @row-click="dianjixuanzhong" border height="100%" size="mini" style="width:100%"
      :header-cell-style="{background:'#F5F5F5',color:'black'}" lazy v-if="tabHeadList.length>0" :row-class-name="tableRowClassName"
      >
        <!-- <el-table-column type="selection" width="120"></el-table-column> -->
        <el-table-column type="index" width="55" label="序号" fixed></el-table-column>
        <template v-for="column in tabHeadList">
          <template v-if="column.enName=='wayStateName'">
            <el-table-column property="" width="100" label="运单状态" :key="column.enName">
              <template slot-scope="scope">
                <span style="color: #E99D42;" v-if="scope.row.wayState==2" >{{scope.row.wayStateName}}</span>
                <span style="color: #D51212;" v-else-if="scope.row.wayState==3" >{{scope.row.wayStateName}}</span>
                <span style="color: #81B337;" v-else-if="scope.row.wayState==4" >{{scope.row.wayStateName}}</span>
                <span style="color: #9A9A9A;" v-else-if="scope.row.wayState==5" >{{scope.row.wayStateName}}</span>
                <span  v-else >{{scope.row.wayStateName}}</span>
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column :key="column.enName" :prop="column.enName" :label="column.cnName" :width="column.fieldWidth" :formatter="formatterRowEmpty" show-overflow-tooltip>
              <template v-for="item in column.child">
                <template v-if="item.enName=='ysSettlementStates'">
                  <el-table-column property="" label="收入结算状态" width="120" :key="item.enName">
                    <template scope="scope">
                      <div>
                        <span class="wsStyle" v-if="scope.row.ysSettlementStates == '未对账'">{{scope.row.ysSettlementStates}}</span>
                        <span class="wsStyle" v-else-if="scope.row.ysSettlementStates == '未收款'">{{scope.row.ysSettlementStates}}</span>
                        <span class="bfStyle" v-else-if="scope.row.ysSettlementStates == '部分收款'">{{scope.row.ysSettlementStates}}</span>
                        <span class="ysStyle" v-else-if="scope.row.ysSettlementStates == '已收款'">{{scope.row.ysSettlementStates}}</span>
                         <span class="ysStyle" v-else-if="scope.row.ysSettlementStates == '不收款'">{{scope.row.ysSettlementStates}}</span>
                        <span class="ysStyle" v-else>-</span>
                      </div>
                    </template>
                  </el-table-column>
                </template>
                <template v-else-if="item.enName=='yfSettlementStates'">
                  <el-table-column property="" label="支出结算状态" width="120" :key="item.enName">
                    <template scope="scope">
                      <div>
                        <span class="wsStyle" v-if="scope.row.yfSettlementStates == '未对账'">{{scope.row.yfSettlementStates}}</span>
                        <span class="wsStyle" v-else-if="scope.row.yfSettlementStates == '未付款'">{{scope.row.yfSettlementStates}}</span>
                        <span class="bfStyle" v-else-if="scope.row.yfSettlementStates == '部分付款'">{{scope.row.yfSettlementStates}}</span>
                        <span class="ysStyle" v-else-if="scope.row.yfSettlementStates == '已付款'">{{scope.row.yfSettlementStates}}</span>
                        <span class="ysStyle" v-else-if="scope.row.yfSettlementStates == '不付款'">{{scope.row.yfSettlementStates}}</span>
                        <span class="ysStyle" v-else>-</span>
                      </div>
                    </template>
                  </el-table-column>
                </template>
                <template v-else-if="item.enName=='yfInvoicingStates'">
                  <el-table-column property="" label="支出开票状态" width="120" :key="item.enName">
                    <template scope="scope">
                      <div>
                        <span class="wsStyle" v-if="scope.row.yfInvoicingStates == '未开票'">{{scope.row.yfInvoicingStates}}</span>
                        <span class="bfStyle" v-else-if="scope.row.yfInvoicingStates == '部分开票'">{{scope.row.yfInvoicingStates}}</span>
                        <span class="ysStyle" v-else-if="scope.row.yfInvoicingStates == '已开票'">{{scope.row.yfInvoicingStates}}</span>
                        <span class="ysStyle" v-else-if="scope.row.yfInvoicingStates == '不开票'">{{scope.row.yfInvoicingStates}}</span>
                        <span class="ysStyle" v-else>-</span>
                      </div>
                    </template>
                  </el-table-column>
                </template>
                <template v-else>
                  <el-table-column :key="item.enName" :prop="item.enName" :label="item.cnName" :width="item.fieldWidth" :formatter="formatterRowEmpty" show-overflow-tooltip>
                  </el-table-column>
                </template>
              </template>
            </el-table-column>
          </template>
        </template>
      </el-table>
    </div>
    <!--分页-->
    <div>
      <el-pagination
        background
        @current-change="handleCurrentChangeA"
        :current-page="searchFrom.pageNo"
        :page-size="searchFrom.pageSize"
        :page-sizes="[25,50,100]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChangeA"
        :total="total"
      ></el-pagination>
    </div>
    <table-heads v-if="tableMark" :tableMark.sync='tableMark' :groupCode="groupCode"></table-heads>
   <export-setting v-if="exportMark" :exportMark.sync='exportMark' :groupCode="groupCode"
   @exportList='exportList'></export-setting>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { getCurrUserDepartment, getCurrUserCompany } from '@/api/newCrm'
import { tenantyQuery, queryMyPageField, getDictionaryDetailList, tenantyQueryTotal } from '@/api/newTMS'
import { emptyFn, dateTimeFormat, formatterRowEmpty, dateFormat1, getLastMonth } from '@/utils/util'
import tableHeads from '@/views/newTMS/publicFiles/tableHeades.vue'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import exportSetting from '@/views/newTMS/publicFiles/exportSetting.vue'
import SearchCollapse from '@/components/common/SearchCollapse.vue'
export default {
  name: 'Freight',
  components: {
    tableHeads,
    exportSetting,
    SearchCollapse
  },
  data () {
    return {
      formatterRowEmpty: formatterRowEmpty,
      groupCode: 'groupReport',
      dateTimeFormat: dateTimeFormat,
      loading: false,
      emptyFn: emptyFn,
      h: '500px',
      xuanzhongArr: [],
      // 查询条件
      createTimes: [],
      actualTimes: [],
      searchFrom: {
        pageNo: 1, // 页数
        pageSize: 50, // 条数
        wayState: 4
      },
      total: 0,
      dataJson: {},
      // 按钮
      btnFlg: [],
      btnIdArr: ['006P00GB001', '006P00GB002'],
      tableList: [],
      tableMark: false,
      tabHeadList: [],
      isDisable: false,
      exportMark: false,
      bumenList: [],
      getCompany: [],
      YWLXlist: [],
      actualLoadingTime: '',
      yfPaymentTime: '',
      ysPaymentTime: '',
      ysInvoiceTime: '',
      yfInvoiceTime: '',
      xmList: [],
      formItemsLength: 0
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/freight')
    // getCurrUserDepartment().then(res => { this.bumenList = res })
    getCurrUserCompany().then(res => { this.getCompany = res })
    getDictionaryDetailList({ dictionaryType: 'project_type' }).then(res => { this.xmList = res })
    this.createTimes = getLastMonth()
    getDictionaryDetailList({ dictionaryType: 'business_type' }).then(res => { this.YWLXlist = res })
    this.queryMyPageField()
    this.getList()
  },
  mounted () {
  },
  methods: {
    // 修改行样式的方法
    tableRowClassName ({ row }) {
      let rowName = ''
      console.log(row.mlrAmount)
      if (row.mlrAmount < 0) {
        rowName = 'warning-row'
      } else {
        rowName = ''
      }
      return rowName
    },
    // 子公司更改
    zigsChangeCX (e) {
      let json1 = this.getCompany.filter(item => item.companyName == e)
      getCurrUserDepartment({ compayCode: json1[0].companyCode }).then(res => { this.bumenList = res })
      this.$set(this.searchFrom, 'departmentName', '')
    },
    // 查询我的页面表头
    queryMyPageField () {
      queryMyPageField({
        // 入参：tagCode 分组编码： 订单列表-> orderPage 运单列表-> wayPage 收支列表-> szPage
        tagCode: this.groupCode
      }).then(res => {
        this.tabHeadList = res
        this.$nextTick(() => {
          this.formItemsLength = this.$refs.searchBox.querySelectorAll('.formItemBox .el-form-item').length
          this.getHeight()
        })
      })
        .catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
    },
    getHeight () {
      this.$nextTick(() => {
        let h = this.$refs.searchBox.offsetHeight
        let pH = document.documentElement.clientHeight
        this.h = (pH - h - 170) + 'px'
      })
    },
    // 获取列表
    getList () {
      this.loading = true
      if (this.searchFrom.wayNo) {
        this.searchFrom.wayNos = this.searchFrom.wayNo.replace(/\n/g, ',')
      } else {
        this.searchFrom.wayNos = ''
      }
      if (this.searchFrom.wbdh) {
        let wbdh = this.searchFrom.wbdh.replace(/\n/g, ',')
        let wbdhArr = wbdh.split(',')
        this.searchFrom.listExternalOrderNumber = wbdhArr
      } else {
        this.searchFrom.listExternalOrderNumber = null
      }
      if (this.searchFrom.ddbh) {
        let ddhStr = this.searchFrom.ddbh.trim()
        this.searchFrom.orderNos = ddhStr.replace(/\n/g, ',')
      } else {
        this.searchFrom.orderNos = ''
      }
      if (this.createTimes) {
        this.searchFrom.startTime = this.createTimes[0]
        this.searchFrom.endTime = this.createTimes[1]
      } else {
        this.searchFrom.startTime = null
        this.searchFrom.endTime = null
      }
      if (this.actualTimes) {
        this.searchFrom.startActualTime = this.actualTimes[0]
        this.searchFrom.endActualTime = this.actualTimes[1]
      } else {
        this.searchFrom.startActualTime = null
        this.searchFrom.endActualTime = null
      }
      if (this.actualLoadingTime) {
        this.searchFrom.startLoadingTime = this.actualLoadingTime[0]
        this.searchFrom.endLoadingTime = this.actualLoadingTime[1]
      } else {
        this.searchFrom.startLoadingTime = null
        this.searchFrom.endLoadingTime = null
      }
      if (this.yfPaymentTime) {
        this.searchFrom.startYfPaymentTime = this.yfPaymentTime[0]
        this.searchFrom.endYfPaymentTime = this.yfPaymentTime[1]
      } else {
        this.searchFrom.startYfPaymentTime = null
        this.searchFrom.endYfPaymentTime = null
      }
      if (this.ysPaymentTime) {
        this.searchFrom.startYsPaymentTime = this.ysPaymentTime[0]
        this.searchFrom.endYsPaymentTime = this.ysPaymentTime[1]
      } else {
        this.searchFrom.startYsPaymentTime = null
        this.searchFrom.endYsPaymentTime = null
      }
      if (this.ysInvoiceTime) {
        this.searchFrom.startYsInvoiceTime = this.ysInvoiceTime[0]
        this.searchFrom.endYsInvoiceTime = this.ysInvoiceTime[1]
      } else {
        this.searchFrom.startYsInvoiceTime = null
        this.searchFrom.endYsInvoiceTime = null
      }
      if (this.yfInvoiceTime) {
        this.searchFrom.startYfInvoiceTime = this.yfInvoiceTime[0]
        this.searchFrom.endYfInvoiceTime = this.yfInvoiceTime[1]
      } else {
        this.searchFrom.startYfInvoiceTime = null
        this.searchFrom.endYfInvoiceTime = null
      }
      tenantyQuery(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
        // this.dataJson = res.map
        this.tableList.forEach((item, index) => {
          this.$set(item, 'createTime', this.dateFormat(item.createTime))
          if (item.actualSigningTime) {
            this.$set(item, 'actualSigningTime', this.dateFormat(item.actualSigningTime))
          }
          if (item.ysPaymentTime) {
            this.$set(item, 'ysPaymentTime', this.dateFormat(item.ysPaymentTime))
          }
          if (item.yfPaymentTime) {
            this.$set(item, 'yfPaymentTime', this.dateFormat(item.yfPaymentTime))
          }
          if (item.ysInvoiceTime) {
            this.$set(item, 'ysInvoiceTime', this.dateFormat(item.ysInvoiceTime))
          }
          if (item.yfInvoiceTime) {
            this.$set(item, 'yfInvoiceTime', this.dateFormat(item.yfInvoiceTime))
          }
          if (item.actualLoadingTime) {
            this.$set(item, 'actualLoadingTime', this.dateFormat(item.actualLoadingTime))
          }
        })
      })
      tenantyQueryTotal(this.searchFrom).then(res => {
        this.dataJson = res
      })
    },
    dateFormat: function (cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = '-'
      } else {
        str =
          t.getFullYear() +
          '-' +
          month +
          '-' +
          date +
          ' ' +
          hour +
          ':' +
          minutes +
          ':' +
          seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    },
    // 点击选中需要修改的行
    dianjixuanzhong (row) {
      this.xuanzhongArr = []
      this.xuanzhongArr = row
    },
    // 查询
    chaxun () {
      this.getList()
    },
    // 重置
    chongZhi () {
      this.searchFrom = {
        pageNo: 1, // 页数
        pageSize: 50, // 条数
        wayState: 4
      }
      // this.createTimes = []
      this.createTimes = getLastMonth()
      this.actualTimes = []
      this.yfPaymentTime = []
      this.ysPaymentTime = []
      this.ysInvoiceTime = []
      this.yfInvoiceTime = []
      this.getList()
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.searchFrom.pageNo = val
      this.getList()
    },
    handleSizeChangeA (val) {
      this.searchFrom.pageSize = val
      this.getList()
    },
    exportList (val) {
      if (this.searchFrom.wayNo) {
        this.searchFrom.wayNos = this.searchFrom.wayNo.replace(/\n/g, ',')
      } else {
        this.searchFrom.wayNos = ''
      }
      if (this.searchFrom.wbdh) {
        let wbdh = this.searchFrom.wbdh.replace(/\n/g, ',')
        let wbdhArr = wbdh.split(',')
        this.searchFrom.listExternalOrderNumber = wbdhArr
      } else {
        this.searchFrom.listExternalOrderNumber = null
      }
      if (this.searchFrom.ddbh) {
        let ddhStr = this.searchFrom.ddbh.trim()
        this.searchFrom.orderNos = ddhStr.replace(/\n/g, ',')
      } else {
        this.searchFrom.orderNos = ''
      }
      if (this.createTimes) {
        this.searchFrom.startTime = this.createTimes[0]
        this.searchFrom.endTime = this.createTimes[1]
      } else {
        this.searchFrom.startTime = null
        this.searchFrom.endTime = null
      }
      if (this.actualTimes) {
        this.searchFrom.startActualTime = this.actualTimes[0]
        this.searchFrom.endActualTime = this.actualTimes[1]
      } else {
        this.searchFrom.startActualTime = null
        this.searchFrom.endActualTime = null
      }
      if (this.actualLoadingTime) {
        this.searchFrom.startLoadingTime = this.actualLoadingTime[0]
        this.searchFrom.endLoadingTime = this.actualLoadingTime[1]
      } else {
        this.searchFrom.startLoadingTime = null
        this.searchFrom.endLoadingTime = null
      }
      if (this.yfPaymentTime) {
        this.searchFrom.startYfPaymentTime = this.yfPaymentTime[0]
        this.searchFrom.endYfPaymentTime = this.yfPaymentTime[1]
      } else {
        this.searchFrom.startYfPaymentTime = null
        this.searchFrom.endYfPaymentTime = null
      }
      if (this.ysPaymentTime) {
        this.searchFrom.startYsPaymentTime = this.ysPaymentTime[0]
        this.searchFrom.endYsPaymentTime = this.ysPaymentTime[1]
      } else {
        this.searchFrom.startYsPaymentTime = null
        this.searchFrom.endYsPaymentTime = null
      }
      if (this.ysInvoiceTime) {
        this.searchFrom.startYsInvoiceTime = this.ysInvoiceTime[0]
        this.searchFrom.endYsInvoiceTime = this.ysInvoiceTime[1]
      } else {
        this.searchFrom.startYsInvoiceTime = null
        this.searchFrom.endYsInvoiceTime = null
      }
      if (this.yfInvoiceTime) {
        this.searchFrom.startYfInvoiceTime = this.yfInvoiceTime[0]
        this.searchFrom.endYfInvoiceTime = this.yfInvoiceTime[1]
      } else {
        this.searchFrom.startYfInvoiceTime = null
        this.searchFrom.endYfInvoiceTime = null
      }
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      form.header = val
      exportExcel(
        this.global.tmsPlus + '/table/exportTenant',
        form,
        '收支报表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 导出
    exportFn () {
      if (this.total > 10000) {
        this.$alert('最多导出10000条数据', '系统提示')
        return
      }
      this.exportMark = true
    },
    tabSetting () {
      this.tableMark = true
    }
  }
}
</script>
<style lang="scss" scoped>

/deep/.el-form{
  width: 100%;
}

.searchBtnBox{
  margin: 10px 0;
}

/deep/.el-table__body tr.warning-row > td {
  background-color: #f9bc04 !important;
}
</style>
